<template>
  <div class="offer--add-offer">
    <div class="list-group-item">
      <form id="add-offer">
        <section-header v-if="offerId == 0" title="New Offer" />
        <b-row v-if="offerId > 0" style="margin-bottom:10px;">
          <b-col cols="1">
            <dt>Offer Number</dt>
            <dd>{{ offer.id }}</dd>
          </b-col>
          <b-col cols="1">
            <dt>Date Created</dt>
            <dd>{{ moment(offer.dateCreated).format(datePickerOptions.format) }}</dd>
          </b-col>
          <b-col cols="1">
            <dt>Created By</dt>
            <dd>{{ offer.createdByUserFullName }}</dd>
          </b-col>
          <b-col cols="1">
            <dt>Date Modified</dt>
            <dd>{{ moment(offer.dateModified).format(datePickerOptions.format) }}</dd>
          </b-col>
          <b-col cols="1">
            <dt>Modified By</dt>
            <dd>{{ offer.modifiedByUserFullName }}</dd>
          </b-col>
          <hr/>
        </b-row>
        <div style="display: grid; grid-template-rows: repeat(1, 1fr); grid-template-columns: repeat(6, 1fr); grid-column-gap: 0.75rem; grid-row-gap: 0rem">
          <b-form-group label="Date Of Offer" style="grid-column: 1; grid-row: 1;" class="mt-1 mr-2 required">
            <date-picker
              v-model="offer.dateOfOffer"
              :config="datePickerOptions"
              :class="{ 'is-invalid': $v.offer.dateOfOffer.$error }"
            ></date-picker>
            <div class="invalid-feedback">
              <div v-if="!$v.offer.dateOfOffer.required">Date Of Offer is required</div>
            </div>
          </b-form-group>
          <b-form-group label="Batch Req #" style="grid-column: 2; grid-row: 1;" class="mt-1 mr-2">
            <b-form-input v-model="offer.vendorRFPNumber" ></b-form-input>
          </b-form-group>

          <b-form-group  label="Vendor" style="grid-column: 3/5; grid-row: 1;" class="mt-1 mr-2 required">
            <b-input-group size="sm">
              <b-input-group-append v-if="checkClaim(CAN_ADD_COMPANY) || checkClaim(CAN_EDIT_COMPANY)">
                <b-button variant="light" @click="showCompanyForm">
                  <i v-if="checkClaim(CAN_ADD_COMPANY)" v-show="this.selectedVendor.id == undefined || this.selectedVendor.id == null || this.selectedVendor.id == 0" class="customer-lookup--plus fa fa-plus"></i>
                  <i v-if="checkClaim(CAN_EDIT_COMPANY)" v-show="this.selectedVendor.id > 0" class="customer-lookup--plus fa fa-pencil"></i>
                </b-button>
              </b-input-group-append>
              <vue-simple-suggest
                class="suggest-input form-control "
                :class="{ 'is-invalid': (this.vendorNameTouched && !chosenVendor) }"
                :styles="autoCompleteStyle"
                :list="getVendorsList"
                :max-suggestions="20"
                :min-length="3"
                :debounce="200"
                v-model="chosenVendor"
                :filter-by-query="true"
                value-attribute="id"
                display-attribute="name"
                @select="onVendorSuggestSelect"
                @input="onVendorSuggestChange"
                @blur="onVendorSuggestBlur"
                @request-done="onRequestDone"
                autocomplete="off"
              >
              <div slot="misc-item-below" v-if="isLoadingVendor" class="misc-item">
                <span>Loading Vendor...</span>
              </div>
              </vue-simple-suggest>
            </b-input-group>
              <div class="invalid-feedback">
                <div v-if="!$v.offer.vendorId.required && !chosenVendor">Vendor is required</div>
              </div>
          </b-form-group>

          <b-form-group label="Contact" style="grid-column: 5; grid-row: 1;" class="mt-1 mr-2 required">
            <b-input-group size="sm">
              <b-input-group-append v-show="selectedVendor.id > 0">
                <b-button variant="light" @click="$refs.addNewContact.newContact()" >
                  <i class="customer-lookup--plus fa fa-plus"></i>
                </b-button>
              </b-input-group-append>
              <b-form-select
                v-model="offer.contactId"
                :class="{ 'is-invalid': $v.offer.contactId.$error }"
                @blur="$v.offer.contactId.$touch()"
                :disabled="!chosenVendor"
              >
                <option
                  v-for="(select, index) in sortSelect(contacts,'firstName')"
                  :key="index"
                  :value="select.id"
                >{{ select.firstName + ' ' + select.lastName }}</option>
              </b-form-select>
            </b-input-group>
            <div class="invalid-feedback">
              <div v-if="!$v.offer.contactId.required">Contact is required</div>
            </div>
          </b-form-group>
        </div>
        <div style="display: grid; grid-template-rows: repeat(4, 1fr); grid-template-columns: repeat(6, 1fr); grid-column-gap: 0.75rem;">
          <b-form-group label="Part #" style="grid-column: 1;" class="required">
            <b-input-group size="sm">
              <b-input-group-append v-if="(checkClaim(CAN_ADD_PARTS) || checkClaim(CAN_EDIT_PARTS))">
                <b-button variant="light" @click="$bvModal.show('part-offer-maintenance-model')">
                  <i v-show="!offer.partId" class="part-lookup--plus fa fa-plus"></i>
                  <i v-show="offer.partId > 0" class="part-lookup--plus fa fa-pencil"></i>
                </b-button>
              </b-input-group-append>
              <vue-simple-suggest
                class="suggest-input form-control"
                :styles="autoCompleteStyle"
                :list="getPartsList"
                v-model="chosenPart"
                :max-suggestions="20"
                :min-length="2"
                :debounce="750"
                :filter-by-query="true"
                value-attribute="id"
                display-attribute="partNumber"
                @select="onPartSuggestSelect"
                @input="onPartSuggestChange"
                :class="{ 'is-invalid': (this.partNumberTouched && !chosenPart) }"
                @blur="onPartNumberSuggestBlur"
                @request-done="onRequestDone"
                >
                <div slot="misc-item-below" v-if="isLoadingPart" class="misc-item">
                  <span>Loading Part...</span>
                </div>
              </vue-simple-suggest>

            </b-input-group>
            <div class="invalid-feedback">
              <div v-if="!chosenPart">Part Number is required</div>
            </div>
          </b-form-group>

          <b-form-group label="Customer PN" style="grid-column: 1;" class="mt-1">
            <b-form-input v-model="offer.customerPN" :disabled="disabledPartFields"></b-form-input>
          </b-form-group>

          <b-form-group label="Alternate PN" style="grid-column: 1;" class="mt-1">
            <b-form-input v-model="part[reqFields.ALT_NUMBER]" :disabled="disabledPartFields"></b-form-input>
          </b-form-group>
          <b-form-group label="NSN" style="grid-column: 1;" class="mt-1">
            <b-form-input :disabled="disabledPartFields" v-model="part[reqFields.NSN_NUMBER]"></b-form-input>
          </b-form-group>
          <b-form-group label="Harmonized Code" style="grid-column: 1;" class="mt-1">
            <b-form-input :disabled="disabledPartFields" v-model="part[reqFields.HARMONIZED_CODE]"></b-form-input>
          </b-form-group>
          <b-form-group label="Schedule B" style="grid-row: 6; grid-column: 1;" class="mt-1">
            <b-form-input :disabled="disabledPartFields" v-model="part[reqFields.SCHEDULE_B]"></b-form-input>
          </b-form-group>
          <b-form-group label="ECCN" style="grid-row: 7; grid-column: 1;" class="mt-1">
            <b-form-input :disabled="disabledPartFields" v-model="part[reqFields.ECCN]"></b-form-input>
          </b-form-group>
            <b-form-group label="Mfr" style="grid-row: 1; grid-column: 2;" class="mr-2">
              <lookup-dropdown label="Manufacturer" moduleName="mfrs" resource="inventoryManufacturer" propKey="inventorymanufacturerId"
                :value="part[reqFields.MANUFACTURER_ID]" :options="manufacturers" @change="onValueChange" :dropdownDisabled="disabledPartFields" />
            </b-form-group>

            <b-form-group label="Description" style="grid-row: 1; grid-column: 3/5" class="mr-2">
              <b-form-input v-model="part[reqFields.DESCRIPTION]" :disabled="disabledPartFields"></b-form-input>
            </b-form-group>

            <b-form-group label="Part Comments" style="grid-row: 1; grid-column: 5/7" class="mr-2">
              <b-form-input :disabled="disabledPartFields" v-model="part.partComments"></b-form-input>
            </b-form-group>
            <b-form-group label="Qty Offered" style="grid-row: 2; grid-column: 2;" class="mr-2 required">
              <b-form-input v-model.number="offer.quantity" type="number"
                :class="{ 'is-invalid': $v.offer.quantity.$error }" @blur="$v.offer.quantity.$touch()" ></b-form-input>
              <div class="invalid-feedback">
                <div v-if="!$v.offer.quantity.required">Quantity is required</div>
              </div>
            </b-form-group>
            <b-form-group label="Qty Available" style="grid-row: 2; grid-column: 3;" class="mr-2">
              <b-form-input v-model.number="offer.quantityAvail" type="number"></b-form-input>
            </b-form-group>
            <b-form-group label="Cost" style="grid-row: 2; grid-column: 4;" class="mr-2 required">
              <b-form-input v-model.number="offer.cost"
              :class="{ 'is-invalid': $v.offer.cost.$error }" @blur="$v.offer.cost.$touch()" @keypress="validateDecimal($event)" type="number" min="0" max="23.99"></b-form-input>
              <div class="invalid-feedback">
                <div v-if="!$v.offer.cost.required">Cost is required</div>
              </div>
            </b-form-group>
            <b-form-group label="Currency" style="grid-row: 2; grid-column: 5;" class="mr-2">
              <lookup-dropdown label="currency" moduleName="currencies" resource="currency" propKey="currencyTypeId"
                :value="offer.currencyTypeId" :options="currencies" @change="onValueChange" />
            </b-form-group>
            <b-form-group label="Exchange Rate" style="grid-row: 2; grid-column: 6;" class="mr-2">
              <b-form-input type="number" min="1"  v-model="offer.exchangeRate" @input="onInputValueChange($event,'convertedCost')"></b-form-input>
            </b-form-group> 
            <b-form-group label="Converted Cost" style="grid-row: 2; grid-column: 7;" class="mr-2">
              <b-form-input type="number" :value="offer.convertedCost" readonly></b-form-input>
            </b-form-group>
            <b-form-group label="Date Code" style="grid-row: 3; grid-column: 2;" class="mr-2">
              <b-form-input v-model="offer.dateCode" ></b-form-input>
            </b-form-group>
            <b-form-group label="Lot" style="grid-row: 3; grid-column: 3;" class="mr-2">
              <b-form-input v-model="offer.lotCode" ></b-form-input>
            </b-form-group>
            <b-form-group label="Revision" style="grid-row: 3; grid-column: 4;" class="mr-2">
              <b-form-input v-model="offer.revision" ></b-form-input>
            </b-form-group>
            <b-form-group label="Testing Req'd" style="grid-row: 3; grid-column: 5;" class="mr-2">
              <b-form-select v-model="offer.tested" >
                  <option :value="null"> </option>
                  <option v-for="(select, index) in sortSelect(testeds,'text')" :key="index" :value="select.value">{{ select.text }}</option>
                </b-form-select>
            </b-form-group>
            
            <b-form-group label="In Stock" style="grid-row: 3; grid-column:6;" class="mr-2">
              <b-form-select v-model="offer.isInStock" >
                  <option :value="null"> </option>
                  <option v-for="(select, index) in sortSelect(testeds,'text')" :key="index" :value="select.value">{{ select.text }}</option>
                </b-form-select>
            </b-form-group>
            <b-form-group label="Vend. Lead Time" style="grid-row: 3; grid-column: 7;" class="mr-2">
              <b-form-input v-model="offer.delivery" ></b-form-input>
            </b-form-group>
            
            <b-form-group label="Condition" style="grid-row: 4; grid-column: 2;" class="mr-2">
              <lookup-dropdown label="condition" moduleName="conditions" resource="inventoryCondition" overrideModalId="offerInventoryCondition"
                propKey="conditionId" :value="offer.conditionId" :options="conditions" @change="onValueChange" />
            </b-form-group>
            <b-form-group label="COO" style="grid-row: 4; grid-column: 3;">
              <b-form-select v-model="offer.countryOfOriginId" >
                <option value="0"> </option>
                <option
                    v-for="(countryCode) in sortSelect(countryCodes)"
                    v-bind:key="countryCode.id"
                    v-bind:value="countryCode.id"
                  >{{countryCode.name}}</option>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Warranty" style="grid-row: 4; grid-column: 4;" class="mr-2">
              <b-form-select v-model="offer.warrantyId" >
                  <option value="0"> </option>
                  <option v-for="(select, index) in sortSelect(warranty)" :key="index" :value="select.id">{{ select.name }}</option>
                </b-form-select>
            </b-form-group>
            <b-form-group label="SPQ" style="grid-row: 4; grid-column: 5;" class="mr-2" disabled>
              <b-form-input v-model="part[reqFields.SPQ]" ></b-form-input>
            </b-form-group>
            <b-form-group label="Min Order Qty" style="grid-row: 4; grid-column: 6;" class="mr-2">
              <b-form-input type="number" v-model="offer.moq" ></b-form-input>
            </b-form-group>
            <b-form-group label="Class" style="grid-row: 6; grid-column: 2;" class="mr-2" :disabled="disabledPartFields">
              <lookup-dropdown label="class" moduleName="classes" resource="inventoryClass" propKey="inventoryclassId"
                :value="part[reqFields.INVENTORY_CLASS_ID]" :options="classes" @change="onValueChange" />
            </b-form-group>
            <b-form-group label="Category" style="grid-row: 6; grid-column: 3;" class="mr-2" disabled>
              <b-form-select v-model="part[reqFields.INVENTORY_CATEGORY_ID]" size="sm">
                <option v-for="(category) in sortSelect(categories)" :key="category.id" :value="category.id">{{category.name}}
                </option>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Packaging" style="grid-row:6; grid-column: 4;" class="mr-2" disabled>
              <lookup-dropdown label="packaging" moduleName="packaging" resource="inventoryPackaging"
                propKey="packageId" :value="part[reqFields.PACKAGE_ID]" :options="packaging" @change="onValueChange" :overrideModalId="'requirements-packaging-modal'" />
            </b-form-group>
            <b-form-group label="Temp" style="grid-row: 6; grid-column: 5;" class="mr-2" disabled>
              <b-form-input v-model="part[reqFields.TEMP_RATING]"></b-form-input>
            </b-form-group>
            <b-form-group label="RoHS" style="grid-row: 6; grid-column: 6;" class="mr-2" disabled>
              <b-form-select v-model="part[reqFields.LEAD_FREE]" id="leadFree" size="sm">
                <option v-for="(value) in leadFreeValues" v-bind:key="value" v-bind:value="value">{{value}}</option>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Trace Info" style="grid-row: 5; grid-column: 2/6">
              <b-form-checkbox v-model="offer.isFullLabelTraceable" inline>Full label, traceable</b-form-checkbox>
              <b-form-checkbox v-model="offer.isLotCodeRemoved" inline>Lot Code removed</b-form-checkbox>
              <b-form-checkbox v-model="offer.isMfrCocPackList" inline>MFR COC/Pack List</b-form-checkbox>
              <b-form-checkbox v-model="offer.isFranchiseCocPackList" inline>Franchise COC/Pack List</b-form-checkbox>
              <b-form-checkbox v-model="offer.isNotTraceable" inline>Not traceable</b-form-checkbox>
            </b-form-group>
            <b-form-group label="Comments" style="grid-row: 7; grid-column: 2/4;" class="mr-2">
              <b-form-input v-model="offer.comment"></b-form-input>
            </b-form-group>

            <b-modal id="part-offer-maintenance-model" ref="partMaintenanceModel" ok-title="Save" scrollable hide-footer :title="partId > 0 ? 'Edit Part' : 'Add Part'">
              <part-form propForm="offer" :partId="partId" :partNumberProp="chosenPart" @cancel="$bvModal.hide('part-offer-maintenance-model')" @partCreated="onPartCreated" @partUpdated="onPartUpdated" />
            </b-modal>
        </div>
        <b-row>
            <b-col>
              <div class="buttons-panel">
                <b-button @click="onRedirect(false)" size="sm">Cancel</b-button>
                <b-button v-if="!offerId"
                  variant="primary"
                  @click="saveOfferAndFinished"
                  size="sm" :disabled="isSaving"
                ><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save &amp; Finish</b-button>
                <b-button v-if="!offerId"
                  variant="primary"
                  @click="saveOfferAndNew"
                          :disabled="isSaving"
                  size="sm"
                ><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save &amp; New</b-button>
                <b-button v-if="offerId"
                  variant="outline-primary"
                  @click="copyOffer"
                          :disabled="isSaving"
                  size="sm"
                ><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Copy Offer</b-button>
                <b-button v-if="offerId"
                  variant="primary"
                  @click="updateOfferAndFinished"
                          :disabled="isSaving"
                  size="sm"
                ><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Update &amp; Finished</b-button>
              </div>
            </b-col>
          </b-row>
      </form>

      <edit-company
        :ref="companyModalId"
        :modalId="companyModalId"
        hiddenButton
        isNewVendor
        :id="selectedVendor.id"
        :companyName="chosenVendor"
        @currentCompany="onCurrentVendor"
        @cancel="chosenVendor = ''"
      />

      <edit-contact
        :companyId="selectedVendor.id"
        ref="addNewContact"
        :inlineButton="true"
        :isQuickAdd="true"
        @created="onContactCreated"></edit-contact>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import VueSimpleSuggest from 'vue-simple-suggest';
import moment from 'moment';
import { FIELDS as REQUIREMENT_FIELDS } from '@/pages/Requirements/constants';
import { DATE_FORMAT, AUTO_COMPLETE_STYLES, VENDOR_ID, LEAD_FREE_VALUES } from '@/shared/constants';
import OffersInfoDto from '@/shared/components/Offers/dto'
import EditCompany from '@/pages/Company/components/EditCompany';
import PartForm from '@/pages/Parts/components/PartForm';
import EditContact from '@/pages/Company/components/CompanyDetails/tabs/Contacts/components/EditContact/index';

export default {
  components: {
    VueSimpleSuggest,
    EditCompany,
    PartForm,
    EditContact
  },
  data() {
    return {
      reqFields: REQUIREMENT_FIELDS,
      chosenVendor: '',
      chosenPart: '',
      selectedVendor: {},
      datePickerOptions: {
        format: DATE_FORMAT,
      },
      autoCompleteStyle: AUTO_COMPLETE_STYLES,
      vendorNameTouched: false,
      partNumberTouched: false,
      part: {
        id: 0,
      },
      testeds: [
        {value: true, text: 'Yes'},
        {value: false, text: 'No'}
        ],
      availabilityList: [],
      offer: {},
      isLoadingVendor: false,
      isLoadingPart: false,
      isSaving: false,
      leadFreeValues: LEAD_FREE_VALUES,
      currentOfferId: 0,
      vendorsList: []
    };
  },
  validations: {
    offer: {
      vendorId: { required },
      vendorRFPId: {  },
      contactId: { },
      dateOfOffer: { required },
      quantity: { required },
      cost: { required }
    },
  },
  watch: {
    currentPart: function() {
      this.part = this.currentPart;
    },
    convertedCost() {
      this.offer.convertedCost = this.convertedCost;
      this.offer.convertedCost=this.offer.convertedCost.toFixed(4);
    },
    totalCost() {
      this.offer.totalCost = this.totalCost;
    },
    async onEditVP() {
      const deleteConfirmed = await this.openConfirmBox({ message: 'Do you want to save your changes?' });
      if (deleteConfirmed) {
        if (this.offer.id) {
          await this.updateOfferAndNew();
        } else {
          await this.saveOfferAndNew();
        }
      }
      this.initializeFields(this.onEditVP.offerId, this.onEditVP.partId);
      },
  },
  props: {
    offerId: [Number, String],
    companyId: [Number, String],
    partId: [Number, String],
    lineId: [Number, String],
    modalId: [String],
    companyModalId: {
      type: String,
      default: 'companyNewOfferForm'
    }
  },
  computed: {
    ...mapState('offers', [
      'clickedAddOfferFromQuotesId'
    ]),
    ...mapGetters('offers', [
      'offerById',
      'contacts',
      'vendors',
      'partNumbers',
      'currentPart',
      'onEditVP'
    ]),
    ...mapGetters('lookup', [
      'classes',
      'currencies',
      'manufacturers',
      'conditions',
      'packaging',
      'vendorRFPAvailabilities',
      'warranty',
      'countryCodes',
      'categories'
    ]),
    disabledPartFields() {
      return !!(this.part && this.part.id);
    },
    convertedCost() {
        //The converted price is the unit price based on the entered price times the exchange rate
      let qty = this.offer.quantity || 0;
      let price = this.offer.cost || 0;
      let exchangeRate = this.offer.exchangeRate || 0;

      return price * exchangeRate;
    },
    totalCost() {
      let qty = this.offer.quantity || 0;
      let price = this.offer.cost || 0;

      return qty * price;
    }
  },
  methods: {
    ...mapActions('offers', [
      'getOfferById',
      'getEmptyOffer',
      'addOffer',
      'updateOfferById',
      'getContacts',
      'clearContacts',
      'getVendors',
      'getCompanyById',
      'getPartNumbers',
      'getAvailability',
      'getPartById',
      'createPart',
      'unsetClickedAddOfferFromQuotesId',
    ]),
    ...mapActions('companies', ['getByNameAndAccountType']),
    ...mapActions('requirements', ['updateLineSource']),
    // ...mapActions('inventory', ['updateInventory']),
    //...mapActions('purchaseorders', ['updatePurchaseOrderLine']),
    redirectToList() {
      this.$router.push({ name: 'requirements' });
    },
    async onContactCreated(id) {
      await this.getContacts(this.offer.vendorId);
      this.offer.contactId = id;
    },
    setSelectedVendor(id, name) {
      this.selectedVendor = {
        id: id,
        name: name
      }
    },
    async onVendorSuggestSelect(suggestion) {
      this.setSelectedVendor(suggestion.id, suggestion.name);
      this.offer.vendorId = suggestion.id;
      this.$v.offer.vendorId.$touch();
      await this.getContacts(suggestion.id);
    },
    async onVendorSuggestChange() {
      this.isLoadingVendor = true;
      if (this.selectedVendor.name && this.chosenVendor !== this.selectedVendor.name) {
        this.selectedVendor = { id: 0 };
        this.offer.vendorId = null;
        this.offer.contactId = null;
        this.$v.offer.vendorId.$touch();
        await this.clearContacts();
      }
    },
    async onCurrentVendor(val) {
      this.setSelectedVendor(val.id, val.name);
      this.offer.vendorId = val.id;
      this.chosenVendor = val.name;
      await this.getContacts(val.id).then(() => {
        if (this.contacts.length > 0){
          this.offer.contactid = this.contacts[0].id;
          this.$v.offer.contactId.$touch();
        }

      });
    },
    async getVendorsList(name) {
      this.vendorsList = await this.getByNameAndAccountType({
        typeId: VENDOR_ID, name});

      return this.vendorsList;
    },
    async onVendorSuggestBlur() {
      this.vendorNameTouched = true;
      if(this.chosenVendor) {
        if (this.vendorsList.length > 0) {
          const findIndex = this.vendorsList.findIndex(x => this.chosenVendor.toLowerCase() == x.name.toLowerCase());

          if (findIndex > -1) {
            this.onVendorSuggestSelect(this.vendorsList[findIndex]);
          } else {
            this.vendorNotFoundConfirmation();
          }
        } else {
          this.vendorNotFoundConfirmation();
        }
      } // New company
    },
    async vendorNotFoundConfirmation() {
      const deleteConfirmed = await this.openConfirmBox({
        message: `${this.chosenVendor} is not in the database. Press Continue to add them.`,
        okTitle: 'Continue',
      });
      if (deleteConfirmed) {
        this.$refs[this.companyModalId].showModal();
      } else {
        this.chosenName = "";
      }
    },
    async onPartNumberSuggestBlur() {
      this.partNumberTouched = true;
      if(this.chosenPart) {
        if (this.partNumbers.length > 0) {
          const findIndex = this.partNumbers.findIndex(x => this.chosenPart.toLowerCase() == x.partNumber.toLowerCase());

          if (findIndex > -1) {
            this.onPartSuggestSelect(this.partNumbers[findIndex]);
          } else {
            this.partNotFoundConfirmation();
          }
        } else {
          this.partNotFoundConfirmation();
        }

      } // New part
    },
     async partNotFoundConfirmation() {
        const deleteConfirmed = await this.openConfirmBox({
          message: `${this.chosenPart} is not in the database. Press Continue to add them.`,
          okTitle: 'Continue',
        });
        if (deleteConfirmed) {
          this.part = { id: 0};
          // this.$refs.partMaintenanceModel.populatePartNumber(this.chosenPartNumber);
          this.$bvModal.show('part-offer-maintenance-model');
        }
    },
    onRequestDone() {
      this.isLoadingVendor = false;
      this.isLoadingPart = false;
    },
    onValueChange({ name, value }) {
      this.offer[name] = value;
    },
    onInputValueChange(value,parameter){
      let val = this.offer['cost'];
      if(val > 0){
        this.offer['cost']*value
        this.offer[parameter]=this.offer['cost']*value;
      }
      else{
        this.offer[parameter]=0;
      }
    },
    
validateDecimal($event) { 
     let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
     if($event.target.value.includes("."))
     {
     // only allow number and one dot
     if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || $event.target.value.indexOf('.') != -1)) { // 46 is dot
      $event.preventDefault();
     }
     // restrict to 2 decimal places
     if($event.target.value !=null && $event.target.value.indexOf(".")>-1 && ($event.target.value.split('.')[1].length > 3)){
     $event.preventDefault();
     }
      }
   },

// let t= event.target.value;  
// let decimalValue = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 5)) : t;

// this.offer.cost=parseFloat(decimalValue);


    async onPartSuggestSelect({ id }) {
      this.offer.partId = id;
      await this.getPartById(id);
    },
    onPartSuggestChange() {
      this.isLoadingPart = true;
      if (this.part.partNumber && this.chosenPart !== this.part.partNumber) {
        this.part = { id: 0};
      }
    },
    async onPartCreated(e) {
      console.log('onPartCreated: ' + e);

      this.$bvModal.hide('part-offer-maintenance-model');
      this.part = {
        ...e,
        partComments: e.comments,
        cost: e.cost || 0
      };
      this.chosenPart = e.partNumber;
      //await this.getPartById(e.id);
      this.offer.partId = this.part.id;
    },
    async onPartUpdated(e) {
      console.log('onPartUpdated: ' , e);
      // console.log('this.partId',this.partId);

      this.$bvModal.hide('part-offer-maintenance-model');
      this.part = {
        ...e,
        partComments: e.comments,
        cost: e.cost || 0
      };

      this.chosenPart = e.partNumber;
      //await this.getPartById(e.id);
      this.offer.partId = this.part.id;
    },
    async getPartsList(partNumber) {
      await this.getPartNumbers(partNumber);
      return this.partNumbers;
    },
    isValidValue(elem) {
      let res = elem != undefined && elem != null && elem;
      return res;
    },
    async checkValidation() {
      console.log('validate form');
      const h = this.$createElement;
      let isInvalid = false;
      let errors = [];

      if(!this.isValidValue(this.chosenVendor) || this.chosenVendor == ''){
        errors.push( h('li', {}, 'You must select a vendor'));
      }

      if(!this.isValidValue(this.offer.contactId)){
        errors.push( h('li', {}, 'You must select a contact'));
      }

      if(!this.isValidValue(this.offer.dateOfOffer) && !this.sourcedObj){
        errors.push( h('li', {}, 'You must select a date offer'));
      }

      if(!this.isValidValue(this.chosenPart) || this.chosenPart == ''){
        errors.push( h('li', {}, 'You must select or create a part'));
      }

      let validationMsg = h('ul', {}, errors);

      if(isInvalid = errors.length > 0){
        this.openAlertBox({message: validationMsg,title: 'Please correct the following'});
      }

      return isInvalid;
    },
    async updateOffer() {
      try {
        this.isSaving = true;

        // var updatingOffer = this.offer;

        let updatingOffer = Object.assign({}, this.offer);

        if (!updatingOffer.partId || this.part.partNumber != this.chosenPart) {
          this.part.id = 0;
          const part = await this.createPart(this.part);
          updatingOffer.partId = part;
        }

        // If we are saving from the Sources tab...
        if (this.sourcedObj != undefined) {
          var lineSource = {
            id: this.offer.id,
            partId: updatingOffer.partId,
            quantity: this.offer.quantity,
            cost: this.offer.cost
          };

          await this.updateLineSource(lineSource);
          this.$emit('updated-source');
          // TODO: Update Line Sources to Offers, Inventory, Purchase Order
          // switch (this.sourcedObj.source) {
          //   case 'Offer':
          //     await this.updateOfferById({ ...this.offer, id: this.sourcedObj.vrfpLineId });
          //     break;
          //   case 'Inventory':
          //     await this.updateInventory({ ...this.offer, id: this.sourcedObj.inventoryId });
          //     break;
          //   case 'PurchaseOrder':
          //     await this.updatePurchaseOrderLine({ ...this.offer, id: this.sourcedObj.purchaseOrderLineId });
          //     break;
          // }
        } else { // Updating from the Offers tab...
          this.$snotify.info('Processsing Offers', 'Offers');
          updatingOffer.active = true;
          updatingOffer.crfqLineId = this.lineId || 0;
          updatingOffer.statusId = 1;

          await this.updateOfferById({offer: updatingOffer, isSamePart: this.partId == updatingOffer.partId});
          this.$snotify.success('Offers Saved', 'Offers');
        }
        this.isSaving = false;
      }catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    },
    async saveOffer() {
      try {
        this.isSaving = true;
        this.$snotify.info('Processsing Offers', 'Offers');
        // var newOffer = this.offer;
        let newOffer = Object.assign({}, this.offer);

        if (!this.part.id || this.part.partNumber != this.chosenPart) {
          this.part.id = 0;
          const part = await this.createPart(this.part);
          newOffer.partId = part;
        }
        newOffer.active = true;
        newOffer.id = 0;
        newOffer.cRFQLineId = this.lineId || 0;
        newOffer.statusId = 1;
        newOffer.vendorRFPId = 0;
        // newOffer.partId = this.part.partId;
        if (!this.offer.tested) {
          newOffer.tested = false;
        }

        var offerId = await this.addOffer({offer: newOffer, isSamePart: this.partId == newOffer.partId});
        this.$snotify.success('Offers Saved', 'Offers');
        this.isSaving = false;
        return offerId;
      }catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    },
    async saveOfferAndFinished() {
      if (await this.checkValidation()) {
        return;
      }
      await this.saveOffer();
      this.onRedirect(true);
    },
    async saveOfferAndNew() {
      if (await this.checkValidation()) {
        return;
      }
      await this.saveOffer();
      let tempOffer = this.offer;
      await this.initializeFields();

      this.offer = {
        ...this.offer,
        contactId: tempOffer.contactId,
        dateOfOffer: tempOffer.dateOfOffer,
        vendorRFPNumber: tempOffer.vendorRFPNumber
      };
      if (this.offer.vendorId > 0) {
        this.$v.offer.vendorId.$invalid = false;
      }

    },
    async copyOffer() {
      if (await this.checkValidation()) {
        return;
      }

      this.offer.dateOfOffer = new Date();
      var offerId = await this.saveOffer();

      if (offerId != 0) {
        this.offer = this.offerById(offerId);
        this.currentOfferId = this.offerId;
      }
    },
    async updateOfferAndFinished() {
      if (await this.checkValidation()) {
        return;
      }
      await this.updateOffer();
      // this.backToRequirements();
      this.onRedirect(true);
    },
    async updateOfferAndNew() {
      if (await this.checkValidation()) {
        return;
      }
      this.updateOffer();
      this.initializeFields();
    },
    onRedirect(isSave = false) {
      console.log(isSave, this.modalId, this.part.partNumber)
      if (isSave && this.modalId === 'item-requirements-offer-form-modaL')
        this.$emit('part-value', this.part.partNumber);
      this.$emit('onDone', isSave);
    },
    showCompanyForm() {
      this.$refs[this.companyModalId].showModal();
    },
    async initializeFields() {
      let chosenVendorId = 0;

      console.log(this.companyId, 'Company Id')
      if (this.companyId) {
        const customer = await this.getCompanyById(this.companyId);

        if (customer) {
          chosenVendorId = customer.Id;
          this.chosenVendor = customer.name;
          this.onVendorSuggestSelect(customer);
        }
      }

      console.log(this.partId, 'Part Id')
      if(this.partId) {
        await this.getPartById(this.partId);
        if(this.part) {
          this.chosenPart = this.part.partNumber;
          this.offer.partId = this.part.id;
          this.part.partComments = this.part.comments;
        }
      } else {
        this.chosenPart = '';
        this.part = { id: 0 }
      }

      console.log(this.offerId, 'Offer Id')
      if (this.offerId) {
        this.offer = await this.getOfferById(this.offerId);
        this.offer.cost=this.offer.cost.toFixed(4);
        this.offer.isInStock=this.offer.isInStock=='YES'?true:false;
        this.currentOfferId = this.offerId;

        let conditionId = null;
        if (this.offer.conditionName) {
          let condition = this.conditions.find(con => con.name === this.offer.conditionName);
          if (condition != undefined) {
            conditionId = condition.id;
          }
        }
        this.offer = { ...this.offer,
              dateOfOffer: moment(this.offer.dateOfOffer).format(DATE_FORMAT), conditionId: conditionId };
      } else {
        this.offer = { ...new OffersInfoDto(), currencyTypeId: 1, exchangeRate: 1, dateOfOffer: moment(new Date()).format(DATE_FORMAT) }
        if (this.companyId && chosenVendorId > 0) {
          this.offer.vendorId = chosenVendor;
        } if (this.part) {
          this.offer.partId = this.part.id;
        }
      }

      console.log(this.offer, "Offer values")
    }
  },
  mounted() {
    this.initializeFields();
  },
  beforeDestroy() {
    this.unsetClickedAddOfferFromQuotesId();
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';
#part-offer-maintenance-model .modal-dialog {
  max-width: 1550px !important;
}

.offer--add-offer {
  .inline-header {
    margin-bottom: 10px;
    padding-bottom: 5px;
    border-bottom: 1px solid $dirtyWhite;
    color: $mutedGray;
    font-weight: bold;

    &.margin-top {
      margin-top: 20px;
    }
  }

  .buttons-panel {
    margin-top: 20px;
    text-align: right;
    .btn {
      margin-left: 10px;
    }
  }

  .form-control.is-invalid {
    padding-right: 0px;
  }

  .vue-simple-suggest.designed {
    .input-wrapper {
      input {
        height: 27px;
        background: transparent;
        padding-right: 30px;
      }
    }
  }
}
</style>